import React from 'react';
import * as contentful from 'contentful';
import ResourceItem from '../components/resource/ResourceItem';

class ResourcePage extends React.Component {  state = {
    posts: []
  }

  client = contentful.createClient({
    space: 'aeekvwazfppz',
    accessToken: '3B6Xb-7HtqZ8Xnx-n2zJUK5tu1sGq8KRisVIueDlYQI'
  })
  
  componentDidMount() {
    this.fetchPosts().then(this.setPosts);
    document.title = 'Resources';
  }  
  
  fetchPosts = () => this.client.getEntries()
  
  setPosts = response => {
    this.setState({
      posts: response.items
    })
  }  
  
  render() {
    return (
        <div className='container'>
            <h1>Helpful Documents</h1>
            <p>When you are applying for internships or jobs, some of these documents might be necessary to fill out in order to get paid or qualify for certain benefits. Please make sure return the filled out document to Jon Mannion at <a href='mailto:jon@bronxsoftware.org?Subject=Important%20Documents%20Submission' target="_top" className='email'>jon@bronxsoftware.org</a> on time.</p>
            <div className='resource'>
                { this.state.posts.map(({fields}, i) =>
                    <ResourceItem key={i} {...fields} />
                )}
            </div>
        </div>
    )
  }
}

export default ResourcePage;